import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import { SnmpV3User, SnmpUserActionsType } from 'data/snmp/snmp.types';
import './snmp-user-grid-menu.scss';

type Props = {
  selectedItem: SnmpV3User | null;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
};

const SnmpUserGridActionMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete
}: Props) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div
      data-testid="SnmpUserGridActionMenu"
      className="snmp-user-action-menu"
    >
      {hasPrivilegesToCreate && (
        <Button
          className="snmp-user-action-menu-button"
          data-testid={`${SnmpUserActionsType.Edit}-button`}
          text={t('collectionFunction.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && (
        <Button
          className="snmp-user-action-menu-button"
          data-testid={`${SnmpUserActionsType.Delete}-button`}
          text={t('collectionFunction.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('sshSecurityInfo.deletePopup.title')}
        displayMessage={t('collectionFunction.deletePopup.message', {
          name: selectedItem.USERNAME
        })}
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default SnmpUserGridActionMenu;
